import {AfterViewInit, Component, OnInit, ViewEncapsulation, Input, EventEmitter, ViewChild} from '@angular/core';
import {AppComponent} from '../app.component';
import {Observable} from 'rxjs';
import {ActivatedRoute, Params} from '@angular/router';
import {Batiment} from '../Models/Batiment';
import {Mobilier} from '../Models/Mobilier';
import {Surface} from '../Models/Surface';
import {Options} from '@angular-slider/ngx-slider';
import {SidebarRecapComponent} from '../sidebar-recap/sidebar-recap.component';
import {cloneDeep, forEach} from "lodash";
import _ from 'lodash';

@Component({
	selector: 'app-piece-par-piece',
	templateUrl: './piece-par-piece.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./piece-par-piece.component.less']
})
export class PieceParPieceComponent implements OnInit {
	prestations: any = [];
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	textes: any = "";
	modalsTxt: any = null;
	textesTabPresta: any = "";
	generalTxtTabPresta: any = "";
	globalTxt: any = "";
	elements: any = [];
	options: any = [];
	arrScaByPicId: any = [];
	mobMobilier: any = null;
	currentPrestaActive: any = null;
	prestaParent: any = null;
	currentCategorie: any = null;
	currentCategorieLibelle: any = null;
	total: any = 0;
	elementsPresta: any = [];
	colsAllPresta: any = [];
	currentCatId: any = null;
	isDetailMur: boolean = false;
	arrSousCat: any = [];
	paramPicId: any;
	paramPicType: any;
	value: number = 50;
	optionsSlider: Options = {
		floor: 0,
		ceil: 100,
		vertical: true,
		showTicksValues: true,
		stepsArray: [
			{value: 0},
			{value: 30},
			{value: 50},
			{value: 70},
			{value: 100},
		]
	};
	test: any = 15;
	arrSrfRfs: any = [];
	currentCatTsfId: any = null;
	arrFinitionsMur: any = [];
	arrFinitionsSol: any = [];
	arrFinitionsPlafond: any = [];

	arrFinitionsPlaDataTreeView: any = [];
	arrFinitionsSolDataTreeView: any = [];
	arrFinitionsMurDataTreeView: any = [];

	objAutreFinition: any = null;
	listTreeLastItems: any = [];

	@ViewChild(SidebarRecapComponent, {static: false}) sbC: any = SidebarRecapComponent;

	//showChild: boolean = true;

	constructor(
		public app: AppComponent,
		private activatedRoute: ActivatedRoute,
		private sidebarRecap: SidebarRecapComponent,
	) {
	}


	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		this.objAutreFinition = null;

		this.app.dataToolsService.currentObjAutreFinition.subscribe(obj => {
			this.objAutreFinition = obj;
			console.log("this.objAutreFinition   => ", this.objAutreFinition);

			this.applyObjAutreFinition();

			// let dmgAutreFin: any = null;

			// if (this.objAutreFinition && this.arrSrfRfs) {
			// 	let finDmgId: number = +this.objAutreFinition.dmgId;
			// 	//alert("this.objAutreFinition")
			// 	this.arrSrfRfs.forEach((groupSrf: any) => {
			// 		dmgAutreFin = groupSrf.arrElementsSelected.filter((srfDmg: any) => {
			// 			console.log("Irene dmgAutreFin srfDmg.DMG_ID => ", srfDmg.DMG_ID);
			// 			console.log("Irene this.objAutreFinition.dmgId => ", this.objAutreFinition.dmgId);
			// 			return (srfDmg.DMG_ID == finDmgId);
			// 		})[0];
			// 		console.log("Irene this.objAutreFinition dmgAutreFin => ", dmgAutreFin);
			// 		if (dmgAutreFin) {
			// 			let finEnCours: any = dmgAutreFin.arrFinitionsSelected.filter((finition: any) => {
			// 				return (finition.DMG_ID == finDmgId && (finition.RFR_ID == -999 || !finition.RFR_ID));
			// 			})[0];
			// 			console.log("Irene this.objAutreFinition finEnCours => ", finEnCours);
			// 			if (finEnCours) {
			// 				finEnCours.RFR_ID = (this.objAutreFinition.fin) ? +this.objAutreFinition.fin.Id : null;
			// 				console.log("Irene finEnCours => ", finEnCours);
			// 				console.log("Irene dmgAutreFin => ", dmgAutreFin);
			//
			// 				let listFin = (dmgAutreFin.TSF_ID == 3) ? this.arrFinitionsMur : dmgAutreFin.arrFinitions;
			//
			// 				if (this.objAutreFinition.fin.Id) {
			//
			// 					let arrayToPass = (dmgAutreFin.TSF_ID == 1) ? this.arrFinitionsPlaDataTreeView : (dmgAutreFin.TSF_ID == 6) ? this.arrFinitionsSolDataTreeView : this.arrFinitionsMurDataTreeView;
			//
			// 					let objInTreeview: any = this.findNodeById(arrayToPass, finEnCours.RFR_ID.toString());
			// 					console.log("objInTreeview => ", objInTreeview);
			//
			// 					if (objInTreeview) {
			//
			// 						let finToPush: any = {
			// 							RFR_ID: +objInTreeview.Id,
			// 							RFR_LIBELLE: objInTreeview.Label,
			// 							disabled: true
			// 						}
			//
			// 						listFin.unshift(finToPush);
			//
			// 						if (dmgAutreFin.TSF_ID != 3) this.onSaveSolOrPlafond(dmgAutreFin);
			// 					}
			// 				} else {
			// 					finEnCours.RFR_ID = null;
			// 				}
			// 			}
			// 		}
			// 	})
			// }
		});

		// ==> On remove du localstorage la modalOpen car c'est un ngInit
		if (localStorage.getItem("modalOpen") != null) localStorage.removeItem("modalOpen");
		// ==> On supprime l'id presta courant et le element id courant
		if (localStorage.getItem("prestaParentId") != null) localStorage.removeItem("prestaParentId");
		if (localStorage.getItem("currentElId") != null) localStorage.removeItem("currentElId");
		// ==> Je recupere quelques params dans l'url
		let paramPicTypeId = this.activatedRoute.snapshot.params['typeId'];

		this.app.sharedToolsService.getJSON("forFunctions").subscribe(prestaOpts => {
			this.elementsPresta = cloneDeep(prestaOpts.fctGetSynthese);
			console.log('this.elementsPresta ==> ', this.elementsPresta);

			this.colsAllPresta = cloneDeep(prestaOpts.fctTypeColToAdd);
			console.log('this.colsAllPresta ==> ', this.colsAllPresta);

			this.elementsPresta.forEach((el: any) => {
				if (el.colsId) {
					el.colsId.forEach((colId: any) => {
						let itemToPush = this.colsAllPresta.filter((col: any) => {
							return (col.id == colId);
						})[0];
						if (itemToPush) el.cols.push(itemToPush);
					});
				}
				if (el.options) {
					el.options.forEach((elChild: any) => {
						if (elChild.colsId) {
							elChild.colsId.forEach((colId: any) => {
								let itemToPush = this.colsAllPresta.filter((col: any) => {
									return (col.id == colId);
								})[0];
								if (itemToPush) elChild.cols.push(itemToPush);
							});
						}
					});
				}
			});

			this.app.sharedToolsService.getJSON('txtModals').subscribe(resp => {
				console.log("resp getJSON('txtModals') ==> ", resp);
				this.modalsTxt = cloneDeep(resp.data);

				this.app.sharedToolsService.getJSON("selectOpts").subscribe(opts => {
					console.log("resp getJSON('selectOpts') ==> ", opts);
					// ==> Je clone dans une variable les options
					let options = cloneDeep(opts);
					console.log("options ==> ", options);
					// ==> Je cree un objet qu'on puisse utiliser plus tard dans d'autres fonctions
					this.options = cloneDeep(opts);

					this.prestations = options.tabsPrestations.filter((prest: any) => {
						return (prest.showInPicId.length == 0 || (prest.showInPicId.length > 0 && prest.showInPicId.indexOf(+paramPicTypeId) != -1));
					});

					// Load the nameJson and initialize the component
					this.app.dataInitService.getNameJsonReady((nameJson) => {
						this.getInfosInit(nameJson);
					});
				});
			});
		});
	}

	// typescript
	private applyObjAutreFinition() {
		if (!this.objAutreFinition || !this.arrSrfRfs || this.arrSrfRfs.length === 0) return;

		const finDmgId = Number(this.objAutreFinition.dmgId);
		const hasSelection = !!(this.objAutreFinition.fin && this.objAutreFinition.fin.Id);
		const finId = hasSelection ? Number(this.objAutreFinition.fin.Id) : null;

		// parcourir les groupes et appliquer la modification même si finId est null (annulation)
		this.arrSrfRfs.forEach((groupSrf: any) => {
			if (!groupSrf.arrElementsSelected) return;

			const dmgAutreFin = groupSrf.arrElementsSelected.find((srfDmg: any) => Number(srfDmg.DMG_ID) === finDmgId);
			if (!dmgAutreFin) return;

			const finEnCours = (dmgAutreFin.arrFinitionsSelected || []).find((finition: any) =>
				(finition.DMG_ID === finDmgId || Number(finition.DMG_ID) === finDmgId) &&
				(Number(finition.RFR_ID) === -999 || !finition.RFR_ID)
			);
			if (!finEnCours) return;

			if (hasSelection) {
				// sélection : remplacer -999 par l'id choisi (nombre)
				finEnCours.RFR_ID = finId;
				const listFin = (dmgAutreFin.TSF_ID === 3) ? this.arrFinitionsMur : (dmgAutreFin.arrFinitions || []);

				// injecter la finition extra si elle n'est pas dans la liste
				const arrayToPass = (dmgAutreFin.TSF_ID === 1)
					? this.arrFinitionsPlaDataTreeView
					: (dmgAutreFin.TSF_ID === 6)
						? this.arrFinitionsSolDataTreeView
						: this.arrFinitionsMurDataTreeView;

				// protection : n'appeler toString() que si finId n'est pas null et arrayToPass existe
				const objInTreeview: any = (finId != null && arrayToPass) ? this.findNodeById(arrayToPass, finId.toString()) : null;

				if (objInTreeview) {
					const finToPush: any = {
						RFR_ID: Number(objInTreeview.Id),
						RFR_LIBELLE: objInTreeview.Label,
						disabled: true
					};
					const exists = (listFin || []).some((f: any) => Number(f.RFR_ID) === finToPush.RFR_ID);
					if (!exists) listFin.unshift(finToPush);
				}

				// persister la modification (conserver la condition métier si nécessaire)
				if (dmgAutreFin.TSF_ID !== 3) this.onSaveSolOrPlafond(dmgAutreFin);
			} else {
				// annulation : vider le champ (remplace -999 par null) et persister
				finEnCours.RFR_ID = null;
				if (dmgAutreFin.TSF_ID !== 3) this.onSaveSolOrPlafond(dmgAutreFin);
			}
		});

		// vider l'objet publié pour éviter réapplications non souhaitées
		this.objAutreFinition = null;
	}

	getInfosInit(_nameJson: any) {
		// Get Settings
		this.app.sharedToolsService.getSettings();

		// ==> New function GET Data en dur
		this.paramPicId = this.activatedRoute.snapshot.params['picId'];
		this.paramPicType = this.activatedRoute.snapshot.params['typeId'];
		console.log("this.paramPicType", this.paramPicType);

		// ==> On recupere la liste des finitions pour les select et les modal treeview
		if (this.paramPicType != -1) {
			this.getDataRefFinitions(this.paramPicId, 1);
			this.getDataRefFinitions(this.paramPicId, 3);
			this.getDataRefFinitions(this.paramPicId, 6);

			this.getDataRefFinitionsAutre(this.paramPicId, 1);
			this.getDataRefFinitionsAutre(this.paramPicId, 3);
			this.getDataRefFinitionsAutre(this.paramPicId, 6);
		}

		this.getMobGroupByScaGet(this.paramPicId);

		// ==> On GET le JSON des Textes globaux
		this.app.dataToolsService.currentGlobalTexts.subscribe(object => {

			// ==> Si l'objet n'est pas encore défini dans les dataTools, alors on appele la fonction dans sharedTools pour remplir l'objet dans les dataTools
			if (!object)
				this.app.sharedToolsService.getGlobalTexts();

			this.globalTxt = object;

			// ==> On GET le JSON des Textes de la page en cours
			this.app.sharedToolsService.getJSON(_nameJson).subscribe(resp => {
				this.textes = cloneDeep(resp.data);
				//this.textesTabPresta = cloneDeep(resp.textesTabPresta);
				this.generalTxtTabPresta = cloneDeep(resp.generalTabPresta);
				//this.headerCols = cloneDeep(resp.headerCols);

				// ==> On prends la prestation numero 4 (par défaut. Définie en dur dans le JSON "selectOpts" - tabsPrestations) et on la rends ACTIVE
				let idActive = this.prestations.filter((opt: any) => {
					return (opt.isTabActive == true);
				})[0];

				let currentPrestaActive: any = JSON.parse(localStorage.getItem("currentPresta")!);


				if (currentPrestaActive) {
					console.log("Active currentPrestaActive ==> ", currentPrestaActive);
					this.getIdVisibleInit(currentPrestaActive.SCA_ID);
					this.getBorderRadiusSpecial(currentPrestaActive.SCA_ID);
				} else {
					// ==> Si la prestation est active, on rajoute les classes pour l'afficher et les classes du border (vu que c'est la numero 1, pour les autres il ne faut pas le faire)
					if (idActive) {
						console.log("Active idActive ==> ", idActive);
						this.getIdVisibleInit(idActive.id);
						this.getBorderRadiusSpecial(idActive.id);
					}
				}

				// ==> On rempli les options à afficher dans chaque prestation
				this.prestations.forEach((prest: any) => {
					//console.log("prest ==> ", prest)
					///prest.arrElementsSelected = [];

					let elementsPresta = cloneDeep(this.elementsPresta);
					if (!elementsPresta || elementsPresta.length < 1) return;
					let prestaInElPresta = elementsPresta.filter((el: any) => {
						return (el.prestaId == prest.id);
					})[0];
					if (prest && prest.id != 99 && prestaInElPresta) prest.cols = prestaInElPresta.cols;
				})
			});
		});
	}

	getIdVisibleInit(_idActive: any) {
		// ==> On rajoute les classes active et show pour la prestation en cours DANS l'INIT
		let _id = document.getElementById('presta_' + _idActive);
		if (_id != null) {
			_id.classList.add("active");
			_id.classList.add("show");
		}
	}

	getBorderRadiusSpecial(_idActive: any) {
		console.log("getIfIsFirstTabLi _idActive ==>", _idActive);
		let boolIsFirst: boolean = false;
		let tabContent = document.querySelector(".tab-content")!;

		let idTabLi = document.getElementById('liScaId_' + _idActive)!;
		if (idTabLi) boolIsFirst = idTabLi.classList.contains("isFirst") ? true : false;

		if (tabContent) {
			if (_idActive == 1 || boolIsFirst)
				tabContent.classList.add("border-radius-special");
			else
				tabContent.classList.remove("border-radius-special");
		}
	}

	getIfIsFirstTabLi() {
		let tabLi = document.querySelectorAll(".tab-li:not(.hidden-li)")!;
		//console.log("getIfIsFirstTabLi tabLi ==>", tabLi);
		if (tabLi && tabLi.length > 0) tabLi[0].classList.add("isFirst");

		let tabLiFirst = document.querySelectorAll(".isFirst")!;
		if (tabLiFirst) {
			console.log("getIfIsFirstTabLi tabLiFirst ==>", tabLiFirst);

			if (tabLiFirst[0] && tabLiFirst[0].classList.length > 0 && tabLiFirst[0].classList.contains("active")) {
				let _idTemp = tabLiFirst[0].id!;
				let _idToPass = _idTemp.replace('liScaId_', '');
				console.log("getIfIsFirstTabLi _idToPass ==>", _idToPass);
				if (_idToPass) this.getBorderRadiusSpecial(_idToPass);
			}
		}
	}

	onClickAutresFinitions(_dataToPass: any, _finition: any) {
		///let autresFinitions = cloneDeep(this.options.autresFinitions);
		console.log("onClickAutresFinitions _finition", _finition);
		console.log("onClickAutresFinitions _dataToPass", _dataToPass);
		console.log("onClickAutresFinitions this.currentCatTsfId", this.currentCatTsfId);
		console.log("onClickAutresFinitions this.arrSrfRfs", this.arrSrfRfs);

		let modal: any = {
			name: "modal-autres-finitions",
			data: _dataToPass,
			dmgId: _finition.DMG_ID
		}

		localStorage.setItem('modalOpen', JSON.stringify(modal));

		//Open modal
		this.app.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
			console.log("Yes clicked");
		}, () => {

			this.clearAutrePlaceholder(_finition.DMG_ID);

			localStorage.removeItem("modalOpen");
			console.log("No clicked");
		})
	}

	private clearAutrePlaceholder(dmgId: any): void {
		if (!this.arrSrfRfs || this.arrSrfRfs.length === 0) return;

		this.arrSrfRfs.forEach((group: any) => {
			const el = group.arrElementsSelected.find((x: any) => Number(x.DMG_ID) === Number(dmgId));
			if (!el?.arrFinitionsSelected?.length) return;

			// si tu as potentiellement 2 finitions, on nettoie toutes celles à -999
			el.arrFinitionsSelected.forEach((fin: any) => {
				if (Number(fin.RFR_ID) === -999) fin.RFR_ID = null;
			});
		});
	}

	onClickRecopy(_arrPrestations: any) {
		console.log("_arrPrestations ==> ", _arrPrestations);

		let prestaActive: any = _arrPrestations.filter((presta: any) => {
			return presta.isTabActive;
		})[0];

		console.log("prestaActive ==> ", prestaActive);

		if (!prestaActive || !prestaActive.arrCategoriesSelected || prestaActive.arrCategoriesSelected.length < 1) {
			this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalRecopierNoElements, "alert", "", () => {
				return;
			}, () => {
				return;
			})
			return;
		}

		let modal: any = {
			name: "modal-recopier-choix",
			data: _arrPrestations,
			paramPicId: this.paramPicId,
			paramPicType: this.paramPicType
		}

		localStorage.setItem('modalOpen', JSON.stringify(modal));

		//Open modal
		this.app.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
			console.log("Yes clicked in modal", modal);
		}, () => {
			localStorage.removeItem("modalOpen");
			console.log("No clicked");
		})
	}

	onClickReglages(_arrPrestations: any) {
		let modal: any = {
			name: "modal-reglages",
			data: _arrPrestations
		}

		localStorage.setItem('modalOpen', JSON.stringify(modal));

		//Open modal
		this.app.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
			console.log("Yes clicked");
		}, () => {
			localStorage.removeItem("modalOpen");
			console.log("No clicked");
		})
	}

	getIfExistsAndPushObjAutre(_array: any) {
		let objAutreFinition = {
			"CPR_REF": "",
			"RFR_ID": -999,
			"RFR_LIBELLE": "AUTRE (plâtrerie, enduit, nettoyage...)",
			"RFR_PICTO_ID": null,
		}

		let objExistsInArr = _array.filter((item: any) => {
			return item.RFR_ID == objAutreFinition.RFR_ID;
		})[0];

		if (!objExistsInArr) _array.push(objAutreFinition);
	}

	getDataRefFinitions(picId: any, tsfId: any) {
		this.app.apiToolsService.rfrRefProduitFilter(picId, tsfId, false).subscribe(resp => {
			console.log("resp rfrRefProduitFilter ==> ", resp);

			if (tsfId == 1) this.arrFinitionsPlafond = cloneDeep(resp);
			if (tsfId == 6) this.arrFinitionsSol = cloneDeep(resp);
			if (tsfId == 3) this.arrFinitionsMur = cloneDeep(resp);

			this.getIfExistsAndPushObjAutre(this.arrFinitionsPlafond);
			this.getIfExistsAndPushObjAutre(this.arrFinitionsSol);
			this.getIfExistsAndPushObjAutre(this.arrFinitionsMur);
		})
	}

	getDataRefFinitionsAutre(picId: any, tsfId: any) {
		this.app.apiToolsService.rfrRefProduitFilter(picId, tsfId, true).subscribe((resp: any) => {
			console.log("resp getDataRefFinitionsAutre ==> ", resp.data);

			if (tsfId == 1) this.arrFinitionsPlaDataTreeView = cloneDeep(resp.data);
			if (tsfId == 6) this.arrFinitionsSolDataTreeView = cloneDeep(resp.data);
			if (tsfId == 3) this.arrFinitionsMurDataTreeView = cloneDeep(resp.data);
		})
	};

	getSrfRfsDmgGet(_picId: any) {
		console.log("getSrfRfsDmgGet function");
		let prestaPeinture: any = null;

		if (this.arrScaByPicId) {
			prestaPeinture = this.arrScaByPicId.filter((_prst: any) => {
				return _prst.SCA_ID == 1;
			})[0];
		}

		//console.log("resp _picId ==> ", _picId);
		this.app.apiToolsService.getSrfRfsDmgGet(_picId).subscribe(resp => {
			console.log("resp getSrfRfsDmgGet ==> ", resp);

			if (prestaPeinture) prestaPeinture.PRIX_TOTAL = 0;

			let arrSurfaces: any = cloneDeep(resp);

			arrSurfaces.forEach((srfTmp: any) => {
				if (srfTmp.TSF_ID == 3) {
					srfTmp.isDoubleFinition = (srfTmp.RFS_NB_FINITIONS == 1) ? false : true;
					srfTmp.valueSlider = this.getValueRfsRefForSlider(srfTmp);
				}

				// ==> Si on reçoit une liste de finitions vide, on cree une finition par défaut
				if (!srfTmp.arrFinitionsSelected || srfTmp.arrFinitionsSelected.length < 1) {

					let finitionTmp: any = {
						DMG_ID: srfTmp.DMG_ID,
						DMG_RFR_PCT: 100,
						RFR_ID: null
					}

					srfTmp.arrFinitionsSelected.push(finitionTmp);
					// ==> S'il y a deux finitions, on cree une autre finition
					if (srfTmp.RFS_NB_FINITIONS == 2) srfTmp.arrFinitionsSelected.push(finitionTmp);
				}

				srfTmp.arrFinitionsSelected.forEach((fin: any) => {
					// ==> Si la surface est de type plafond ou sol et que le rfrId est 0, on le met à null.
					fin.RFR_ID = ((srfTmp.TSF_ID == 1 || srfTmp.TSF_ID == 6) && fin.RFR_ID == 0) ? null : fin.RFR_ID;
					//// ==> On rajoute pour toutes les finitions le isFinValid pour affichage ou pas du message d'erreur quand la saisie est obligatoire
					//fin.isFinValid = true;
				});
			});

			// ==> On group les surfaces par type pour l'affichage de premier niveau
			let surfacesGrouped: any = _.chain(arrSurfaces).groupBy("TSF_ID").map((value, key) => ({
				TSF_ID: key,
				arrElementsSelected: value
			})).value();

			// ==> On clone les surfaces groupées dans l'array qui sert au ngFor
			this.arrSrfRfs = cloneDeep(surfacesGrouped);

			this.applyObjAutreFinition();

			this.arrSrfRfs.forEach((srfType: any) => {
				console.log("FCT getSrfRfsDmgGet srfType ==> ", srfType);

				srfType.PRIX_TOTAL_MURS = 0;

				// ==> On recupère les valeurs pour les select des finitions selon le type de surface
				srfType.arrElementsSelected.forEach((el: any) => {
					if (!el.DMG_RENOVER) return;

					if (el.TSF_ID != 3) el.arrFinitions = this.getFinitionsByTsfId(el.TSF_ID);
					// ==> On calcule le prix total des murs
					else srfType.PRIX_TOTAL_MURS += el.DMG_PRIX;

					// ==> Presta total peinture
					setTimeout(() => {
						if (prestaPeinture) prestaPeinture.PRIX_TOTAL += el.DMG_PRIX;
					}, 1);

					// ==> On recupère la valeur de l'array du treeview si c'est un autre type de finition
					this.fctWhenIsAutreSelected(el);
				})
			})
		})
	}

	// ==> GET ALL PRESTA FOR PIC
	getMobGroupByScaGet(_picId: any) {
		console.log("resp _picId ==> ", _picId);

		this.app.apiToolsService.getMobGroupByScaGet(_picId).subscribe(resp => {
			console.log("resp getMobGroupByScaGet ==> ", resp);
			console.log("_picId getMobGroupByScaGet ==> ", _picId);

			this.arrScaByPicId = cloneDeep(resp);

			let localPresta = JSON.parse(localStorage.getItem("currentPresta")!);
			//console.log("localPresta ==> ", localPresta);

			this.arrScaByPicId.forEach((sca: any) => {

				let prestaInJson: any = this.elementsPresta.filter((prst: any) => {
					return prst.prestaId == sca.SCA_ID;
				})[0];
				let prestaFromJson = this.options.tabsPrestations.filter((prest: any) => {
					return prest.id == sca.SCA_ID
				})[0];

				if (prestaInJson) {
					sca.avecDepose = (prestaInJson.avecDepose) ? prestaInJson.avecDepose : false;
					sca.avecCanalisation = (prestaInJson.avecCanalisation) ? prestaInJson.avecCanalisation : false;
					sca.avecCablerie = (prestaInJson.avecCablerie) ? prestaInJson.avecCablerie : false;
					sca.encastre = (prestaInJson.encastre) ? prestaInJson.encastre : false;
					sca.cols = (prestaInJson.cols) ? prestaInJson.cols : [];
					sca.optionsCategories = (prestaInJson.options) ? prestaInJson.options : [];
				}

				sca.isHidden = ((sca.SCA_ID == 6 && this.paramPicType != '12') || ((sca.SCA_ID == 1 || sca.SCA_ID == 5) && this.paramPicType == '-1')) ? true : false;
				//console.log("resp getMobGroupByScaGet ==> ", sca);

				sca.isTabActive = false;

				if (localPresta) {
					if (localPresta.SCA_ID != 99) {
						if (sca.SCA_ID == localPresta.SCA_ID) sca.isTabActive = true;
					} else {
						if (sca.SCA_ID == localPresta.idParent) sca.isTabActive = true;
					}
				} else {
					sca.isTabActive = (prestaFromJson) ? prestaFromJson.isTabActive : false;
				}

				if (sca.isTabActive) {
					this.getIdVisibleInit(sca.SCA_ID);
					this.getBorderRadiusSpecial(sca.SCA_ID);
					setTimeout(() => {
						this.getIfIsFirstTabLi();
					}, 1)
				}

				// ==> Formatter les Elements
				if (sca.arrCategoriesSelected && sca.arrCategoriesSelected.length > 0) {
					sca.arrCategoriesSelected.forEach((cat: any) => {
						cat.CMO_ID_ROOT = (cat.CMO_ID_ROOT) ? parseInt(cat.CMO_ID_ROOT) : cat.CMO_ID_ROOT;

						if (cat.arrElementsSelected && cat.arrElementsSelected.length > 0) {
							cat.arrElementsSelected.forEach((el: any) => {
								//console.log("Formatter les Elements ==> ", el);

								el.isDefinitelyAdded = true;
								el.hasDetail = (el.CMO_REF_ROOT != el.CMO_REF) ? true : false;
								el.CMO_ID = (el.CMO_ID) ? parseInt(el.CMO_ID) : el.CMO_ID;
								el.CMO_ID_ROOT = (el.CMO_ID_ROOT) ? parseInt(el.CMO_ID_ROOT) : el.CMO_ID_ROOT;

								let currentElInJson = prestaInJson.options.filter((elJson: any) => {
									return (elJson.cmoRef == el.CMO_REF);
								})[0];
								//console.log("currentElInJson el ==> ", currentElInJson);
								let obligatoires: any = [];

								if (currentElInJson) {
									el.colsId = (currentElInJson.colsId) ? currentElInJson.colsId : [];
									el.cols = (currentElInJson.cols) ? currentElInJson.cols : [];

									el.cols.forEach((col: any) => {
										if (col.model && col.isOblig) obligatoires.push(col.model);
									})

									el.obligatoires = cloneDeep(obligatoires);
									el.hasDetail = (currentElInJson.hasDetail) ? currentElInJson.hasDetail : el.hasDetail;
									//el.hasDetailInModal = (currentElInJson.hasDetailInModal) ? true : false;
									////console.log("el ==> ", el);
								}

								el.synthese = cloneDeep(prestaInJson);
								el.isDetail = false;
								el.MOB_STANDING = (!el.MOB_STANDING) ? this.batiment.niveauStanding : el.MOB_STANDING;
								el.MOB_PRIX = (el.MOB_PRIX) ? el.MOB_PRIX : 0;
								el.MOB_PRIX_TOTAL = +el.MOB_PRIX;

								//if (el.MOB_NB > 1) el.MOB_PRIX_TOTAL = +el.MOB_PRIX * +el.MOB_NB;

								el.MOB_PRIX_TOTAL = +el.MOB_PRIX_TOTAL.toFixed(2)

								//if (el.isDefinitelyAdded) {
								let arrSousCat: any;

								// ==> Ici on recupere par api les enfants de la categorie selectionnee
								this.app.apiToolsService.getElementsByIdMere(parseInt(cat.CMO_ID_ROOT)).subscribe(resp => {
									// console.log("resp getElementsByIdMere ==> ", resp);
									// console.log("cat.CMO_ID_ROOT ==> ", cat.CMO_ID_ROOT);
									arrSousCat = cloneDeep(resp);
									el.arrSousCat = JSON.parse(arrSousCat);
								})
								//}
							});
						}
					});
				}

				this.calculTotalPrix(sca);
			})

			this.getSrfRfsDmgGet(this.paramPicId);

			// ==> On rajoute dans toutes les arrPrestations, la presta pour l'affichage du détail. à effacer avant sauvegarde
			let tabPrestaDetail = this.options.tabsPrestations.filter((sca: any) => {
				return sca.id == 99
			})[0];

			if (tabPrestaDetail) {
				///console.log("tabPrestaDetail ==> ", tabPrestaDetail);
				let newPresta: any = {
					SCA_ID: tabPrestaDetail.id,
					SCA_LIBELLE: tabPrestaDetail.label,
					SCA_PICTOGRAMME: tabPrestaDetail.picto,
					isTabActive: false,
				}

				this.arrScaByPicId.push(newPresta);
			}

			//console.log("this.arrScaByPicId ==> ", this.arrScaByPicId);

			setTimeout(() => {
				let currentPresta: any = null;
				//let prestaParentId: any = localStorage.getItem("prestaParentId");
				//console.log("prestaParentId 1 ==> ", prestaParentId);

				if (this.arrScaByPicId) currentPresta = this.arrScaByPicId.filter((_prst: any) => {
					return _prst.isTabActive;
				})[0];
				console.log("currentPresta ==> ", currentPresta);

				let currentPrestaActive: any = JSON.parse(localStorage.getItem("currentPresta")!);

				// ==> Seulement pour cacher le bouton Recopier les choix dans la presta Amenagement
				this.currentPrestaActive = currentPrestaActive;
				console.log("this.currentPrestaActive ==> ", this.currentPrestaActive)

				//console.log("currentPrestaActive ==> ", currentPrestaActive);
				if (currentPrestaActive) {
					if (currentPrestaActive.SCA_ID != 99) {

						// ==> On voit si la current presta active est affichée ou pas dans la piece en cours, sinon on cherche la premiere presta qui est affiché pour changer sur elle
						currentPrestaActive.isHidden = ((currentPrestaActive.SCA_ID == 6 && this.paramPicType != '12') || ((currentPrestaActive.SCA_ID == 1 || currentPrestaActive.SCA_ID == 5) && this.paramPicType == '-1')) ? true : false;

						if (currentPrestaActive.isHidden) {
							let prestaActiveFirst = this.arrScaByPicId.filter((_prst: any) => {
								return !_prst.isHidden;
							})[0];
							console.log("prestaActiveFirst", prestaActiveFirst)
							if (prestaActiveFirst) this.changeTabNew(this.arrScaByPicId, prestaActiveFirst);
						} else {
							this.changeTabNew(this.arrScaByPicId, currentPrestaActive);
						}
					} else {
						if (currentPresta) this.changeTabNew(this.arrScaByPicId, currentPresta);
					}
				} else {
					if (currentPresta) this.changeTabNew(this.arrScaByPicId, currentPresta);
				}
			}, 150);
		})
	}

	// ==> CREATE or EDIT Mobilier
	setMobMobilierSet(_mob: any) {
		_mob.CMO_ID = (_mob.CMO_ID) ? parseInt(_mob.CMO_ID) : _mob.CMO_ID;
		_mob.MOB_ID = (!_mob.MOB_ID) ? -1 : _mob.MOB_ID;
		delete _mob.MOB_HAUTEUR;
		delete _mob.MOB_LARGEUR;
		console.log("_mob envoyé ==> ", _mob);

		this.app.apiToolsService.setMobMobilierSet(_mob).subscribe(resp => {
			console.log("resp setMobMobilierSet ==> ", resp);
			let response: any = resp;

			if (response.Status == 'OK') {
				console.log("this.paramPicId ==> ", this.paramPicId);

				//récupe les données de la sidebar et màj le prix
				//this.sidebarRecap.getSimulationEncart(this.batiment.simulationId);
				//this.sbC.update();

				this.sidebarRecap.getSimulationEncart(this.batiment.simulationId);
				this.sbC.update();
				this.getMobGroupByScaGet(this.paramPicId);
				//location.reload();
			}
		})
	}

	// ==> DELETE Mobilier
	delMobMobilierDel(_mob: any) {
		console.log("_mob récupéré ==> ", _mob);

		this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalSupp, "confirm", "", () => {
			console.log("Yes clicked");

			// ==> On trouve l'id parent à supprimer de la liste et on le supprime
			this.app.apiToolsService.delMobMobilierDel(_mob, _mob.MOB_ID).subscribe(resp => {
				console.log("resp delMobMobilierDel ==> ", resp);
				let response: any = resp;

				if (response.Status == 'OK') {
					console.log("this.paramPicId ==> ", this.paramPicId);
					this.sidebarRecap.getSimulationEncart(this.batiment.simulationId);
					this.sbC.update();
					this.getMobGroupByScaGet(this.paramPicId);
				}

				// if (response.Status == 'OK') {
				//   console.log("this.paramPicId ==> ", this.paramPicId);
				//   this.getMobGroupByScaGet(this.paramPicId);
				// }
			})

			return;
		}, () => {
			console.log("No clicked");
			return;
		})
	}

	// ==> SAVE specifications presta
	setStpStatuePrestaSet(_stp: any) {

		let objStp: any = {
			//STP_ID: _stp.STP_ID,
			PIC_ID: this.paramPicId,
			SCA_ID: _stp.SCA_ID,
			STP_IS_SELECTED: _stp.STP_IS_SELECTED,
			STP_AVEC_DEPOSE: _stp.STP_AVEC_DEPOSE,
			STP_AVEC_CANALISATIONS: _stp.STP_AVEC_CANALISATIONS,
			STP_AVEC_CABLERIE: _stp.STP_AVEC_CABLERIE,
			STP_ENCASTRE: _stp.STP_ENCASTRE
		}

		//_mob.CMO_ID = (_mob.CMO_ID) ? parseInt(_mob.CMO_ID) : _mob.CMO_ID;
		console.log("_stp récupéré ==> ", _stp);
		console.log("objStp envoyé ==> ", objStp);

		this.app.apiToolsService.setStpStatuePrestaSet(objStp).subscribe(resp => {
			console.log("resp setStpStatuePrestaSet ==> ", resp);

			// ==> récupère les données de la sidebar et màj le prix
			this.sidebarRecap.getSimulationEncart(this.batiment.simulationId);
			this.sbC.update();
			this.getMobGroupByScaGet(this.paramPicId);

			//location.reload();
		})
	}

	// ==> SAVE le mobilier
	saveMobilier(_objMob: any) {
		console.log("_objMob ==> ", _objMob);

		let nbErrors: any = 0;
		nbErrors = this.checkValidators(_objMob);

		// ==> Si c'est un mobilier qui nécéssite de saisir h (200) & l (201), on calcule la surface
		let ishxlRequired = false;
		ishxlRequired = (_objMob.synthese && _objMob.synthese.colsId?.indexOf(200) != -1 && _objMob.synthese.colsId?.indexOf(201) != -1)
			|| (_objMob.cols && _.findIndex(_objMob.cols, {'id': 200}) != -1 && _.find(_objMob.cols, {'id': 201}) != -1);

		if (ishxlRequired) {
			let h = parseInt(_objMob.MOB_HAUTEUR);
			let l = parseInt(_objMob.MOB_LARGEUR);

			if (isNaN(h) || isNaN(l)) {
				this.app.confirmDialogService.confirmThis("", "Vous devez indiquer une hauteur (h en cm) et une largeur (l en cm)", "alert", "", () => {
					return;
				}, () => {
					return;
				});

				nbErrors++;
			} else {
				let surface = h * l / 10000;
				console.log("surface :", surface.toFixed(2));
				_objMob.MOB_SURFACE = surface;
			}
		}

		console.log('nbErrors => ', nbErrors);
		if (nbErrors > 0) return;

		this.setMobMobilierSet(_objMob);
	}

	// ==> CHANGE de presta
	changeTabNew(_arrPresta: any, _presta: any) {
		//console.log("_arrPresta changeTabNew ==> ", _arrPresta);
		console.log("_presta changeTabNew ==> ", _presta);

		// ==> On rajoute dans le localstorage la current presta pour quand on recupere les infos apres chaque sauvegarde, on revient à la meme presta
		localStorage.setItem("currentPresta", JSON.stringify(_presta));

		// ==> Seulement pour cacher le bouton Recopier les choix dans la presta Amenagement
		let currentPrestaActive: any = JSON.parse(localStorage.getItem("currentPresta")!);
		this.currentPrestaActive = currentPrestaActive;
		console.log("this.currentPrestaActive ==> ", this.currentPrestaActive)

		// ==> On supprime l'id presta courant et le element id courant
		if (_presta.SCA_ID != 99) {
			if (localStorage.getItem("prestaParentId") != null) localStorage.removeItem("prestaParentId");
			if (localStorage.getItem("currentElId") != null) localStorage.removeItem("currentElId");
			this.isDetailMur = false; //on force la sortie de l'afficahge détail mur
		}

		// ==> On vide l'objet mobMobilier
		if (this.mobMobilier) this.mobMobilier = null;

		// ==> Pour toutes les prestations, on met le KEY isTabActive à false
		_arrPresta.forEach((prest: any) => {
			prest.isTabActive = false;
			prest.hasDetailActive = false;
		});

		// ==> On met le KEY isTabActive à true pour celle où on a cliqué
		_presta.isTabActive = true;

		let prestaParentInArrayPresta = _arrPresta.filter((prs: any) => {
			return prs.SCA_ID == _presta.SCA_ID
		})[0];
		//console.log("prestaParentInArrayPresta ==> ", prestaParentInArrayPresta);

		if (prestaParentInArrayPresta) {
			// ==> On met le KEY isTabActive à true pour celle où on a cliqué dans l'item de l'array
			prestaParentInArrayPresta.isTabActive = true;
		}

		// ==> On définit le border radius de la première prestation lorsqu'elle est active car le border est différent des autres
		this.getBorderRadiusSpecial(_presta.SCA_ID);
		setTimeout(() => {
			this.getIfIsFirstTabLi();
		}, 1)

		let prestaParent = _arrPresta.filter((prs: any) => {
			return prs.SCA_ID == _presta.idParent
		})[0];

		if (_presta.SCA_ID == 99 && prestaParent) {
			prestaParent.isTabActive = false;
			prestaParent.hasDetailActive = true;

			this.getBorderRadiusSpecial(prestaParent.SCA_ID);
			setTimeout(() => {
				this.getIfIsFirstTabLi();
			}, 1)
		}

		// ==> On prends les div qui ont les classes active et show et on enleve ces classes là
		let elems = document.querySelector(".active.show");
		if (elems !== null) {
			elems.classList.remove("active");
			elems.classList.remove("show");
		}
		// ==> On prends le div de la prestation en cours et on rajoute les classes active et show pour l'afficher
		let _id = document.getElementById('ScaId_' + _presta.SCA_ID);
		//console.log("Id Presta en cours ==================================================> ", _id);

		if (_id != null) {
			_id.classList.add("active");
			_id.classList.add("show");
		}
	}

	// ==> Functions pour les onChange des cat, souscat et matériels
	onChangeCmoRoot(_mob: any, _presta: any) {
		console.log('_mob ==> ', _mob);
		// ==> On remet le rfmId à null et on vide la liste des champs obligatoires
		_mob.RFM_ID = null;
		_mob.obligatoires = [];

		let activePresta = this.arrScaByPicId.filter((sca: any) => {
			return sca.SCA_ID == _presta.SCA_ID;
		})[0];
		console.log('activePresta ==> ', activePresta);

		// ==> Sécurité : si jamais pas de presta active, on return
		if (!activePresta) return;

		// ==> On verifie que la categorie parent n'est pas dans la liste + hasDetail ou que elle y est mais qu'il n'y a qu'un choix
		let objectSelected: any = (activePresta.optionsCategories && activePresta.optionsCategories.length > 0) ? activePresta.optionsCategories.filter((elCat: any) => {
			return elCat.cmoRef == _mob.CMO_REF_ROOT;
		})[0] : null;

		//console.log('objectSelected ==> ', objectSelected);

		let catIdParentExists: any = (activePresta.arrCategoriesSelected && activePresta.arrCategoriesSelected.length > 0) ? activePresta.arrCategoriesSelected.filter((cat: any) => {
			return cat.CMO_REF_ROOT == _mob.CMO_REF_ROOT;
		})[0] : null;
		console.log('catIdParentExists ==> ', catIdParentExists);

		if (objectSelected) this.mobMobilier.hasDetail = objectSelected.hasDetail;

		let catIdParentIsAlreadyInList: boolean = (catIdParentExists && this.mobMobilier.hasDetail) ? true : false;

		if (catIdParentIsAlreadyInList) {
			this.returnAlertItemExists(_presta);
		} else {
			if (objectSelected) {
				console.log('objectSelected ==> ', objectSelected);
				this.mobMobilier.hasDetail = objectSelected.hasDetail;
				this.mobMobilier.hasDetailInModal = (objectSelected.hasDetailInModal) ? objectSelected.hasDetailInModal : false;
				//let obligatoires: any = [];

				this.mobMobilier.cols = cloneDeep(objectSelected.cols);
				console.log("this.mobMobilier.cols ==> ", this.mobMobilier.cols);

				//this.mobMobilier.obligatoires = cloneDeep(obligatoires);
				console.log("this.mobMobilier ==> ", this.mobMobilier);

				// ==> S'il n'y a pas de détail, on récupère pour le mobilier en cours une array de sous catégories en passant la catégorie selectionnée
				if (!this.mobMobilier.hasDetail) {
					let arrSousCat: any;
					this.app.apiToolsService.getElementsByIdMere(parseInt(objectSelected.cmoId)).subscribe(resp => {
						//console.log("resp getElementsByIdMere ==> ", resp);
						arrSousCat = cloneDeep(resp);
						this.mobMobilier.arrSousCat = JSON.parse(arrSousCat);
					})
				}
				// ==> Sinon, on récupère par api les enfants de la catégorie selectionnée dans this.arrSousCat
				else {
					if (!this.mobMobilier.hasDetailInModal) {
						this.arrSousCat = [];
						this.getElementsByIdMere(objectSelected.cmoId);
					}
				}
			}
		}
	}

	onChangeCmoId(_mob: any, _presta: any) {
		_mob.RFM_ID = null;
		this.mobMobilier.listRfm = _mob.arrSousCat.filter((cmo: any) => {
			return cmo.CMO_ID == _mob.CMO_ID
		})[0].LIST_RFM;
		console.log("this.mobMobilier", this.mobMobilier)
	}

	onChangeRfmId(_mob: any, _presta: any) {
		console.log('_mob before ==> ', _mob);

		//_mob.MOB_STANDING = this.batiment.niveauStanding;
		_mob.MOB_NB = (_mob.MOB_NB) ? _mob.MOB_NB : 1;
		_mob.MOB_STANDING = (!_mob.MOB_STANDING) ? this.batiment.niveauStanding : _mob.MOB_STANDING;
		//let prix: any = this.returnPrixMobMobilier(_mob);
		_mob.MOB_PRIX_TOTAL = null;
		_mob.MOB_PRIX = 0;
		//_mob.MOB_PRIX = (prix) ? prix * _mob.MOB_NB : 0;

		// ==> On rajoute les validators
		let obligatoires: any = []
		_mob.cols.forEach((col: any) => {
			if (col.model && col.isOblig) obligatoires.push(col.model);
		})
		_mob.obligatoires = cloneDeep(obligatoires);

		let rfmSelected: any = _mob.arrSousCat[0].LIST_RFM.filter((rfm: any) => {
			return rfm.RFM_ID == _mob.RFM_ID;
		})[0];
		console.log('rfmSelected ==> ', rfmSelected);

		console.log('_mob after ==> ', _mob);

		let activePresta = this.arrScaByPicId.filter((sca: any) => {
			return sca.SCA_ID == _presta.SCA_ID;
		})[0];
		console.log('activePresta ==> ', activePresta);

		let rfmIdParentCatExists: any = (activePresta.arrCategoriesSelected && activePresta.arrCategoriesSelected.length > 0) ? activePresta.arrCategoriesSelected.filter((cat: any) => {
			return cat.CMO_REF_ROOT == _mob.CMO_REF_ROOT;
		})[0] : null;

		console.log('rfmIdParentCatExists ==> ', rfmIdParentCatExists);

		if (!rfmIdParentCatExists) return;

		let mobIsAlreadyInList: any = (rfmIdParentCatExists.arrElementsSelected && rfmIdParentCatExists.arrElementsSelected.length > 0) ? rfmIdParentCatExists.arrElementsSelected.filter((rfm: any) => {
			return rfm.RFM_ID == _mob.RFM_ID;
		})[0] : null;

		console.log('mobIsAlreadyInList ==> ', mobIsAlreadyInList);

		if (mobIsAlreadyInList) this.returnAlertItemExists(_presta);
	}

	// => Functions pour la récup des items pour le select selon le cmoIdMere et selon hasdetail ou pas
	getElementsNoDetailByIdMere(_cmoIdMere: any) {
		console.log("resp _cmoIdMere ==> ", _cmoIdMere);
		let arrSousCat: any;
		let arrSousCatJson: any;
		this.app.apiToolsService.getElementsByIdMere(parseInt(_cmoIdMere)).subscribe(resp => {
			console.log("resp getElementsByIdMere ==> ", resp);
			arrSousCat = cloneDeep(resp);
			arrSousCatJson = JSON.parse(arrSousCat)
			//_element.arrSousCat = JSON.parse(arrSousCat);
			//console.log("this.arrSousCat", this.arrSousCat);
		})

		return arrSousCatJson;
	}

	getElementsByIdMere(_cmoIdMere: any) {
		console.log("resp _cmoIdMere ==> ", _cmoIdMere);

		this.app.apiToolsService.getElementsByIdMere(parseInt(_cmoIdMere)).subscribe(resp => {
			//console.log("resp getElementsByIdMere ==> ", resp);
			let arrSousCat: any = cloneDeep(resp);
			this.arrSousCat = JSON.parse(arrSousCat);

			//console.log("this.arrSousCat", this.arrSousCat);

			if (this.currentCategorie) {
				this.currentCategorie.arrElementsSelected.forEach((el: any) => {
					el.currentSousCat = this.arrSousCat.filter((item: any) => {
						return item.CMO_ID == el.CMO_ID
					})[0];
					console.log("el", el);
				})
			}
		})
	}

	// ==> Functions VRAC
	returnPrixMobMobilier(_mob: any) {
		let prix: any = null;
		prix = _mob['MOB_PRIX_UNIT_HT' + _mob.MOB_STANDING.toString()];

		console.log('prix ==> ', prix);
		return prix;
	}

	returnAlertItemExists(_presta: any) {
		this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalMatAlreadyAdded, "alert", "", () => {
			console.log("Yes clicked");
			// ==> On vide les champs du mob et on return
			this.mobMobilier = this.returnNewMobObject(_presta);
			this.addNewMobMobilier(_presta);
			return;
		}, () => {
			console.log("No clicked");
		})
	}

	returnNewMobObject(_presta: any) {
		let mobMobilier: any = new Mobilier();
		mobMobilier.CMO_REF_ROOT = null;
		mobMobilier.PIC_ID = parseInt(this.paramPicId);
		mobMobilier.SCA_ID = _presta.SCA_ID;

		return mobMobilier;
	}

	// ==> EDIT Mobilier
	onEditElement(_el: any) {
		console.log("_el ============> ", _el);
	}

	// ==> ADD Mobilier
	addNewMobMobilier(_presta: any) {
		console.log('_presta ==> ', _presta);
		let currentCmoRefRoot: any = localStorage.getItem('currentElId');

		let objectSelected: any = (_presta.optionsCategories && _presta.optionsCategories.length > 0 && currentCmoRefRoot) ? _presta.optionsCategories.filter((elCat: any) => {
			return elCat.cmoRef == currentCmoRefRoot;
		})[0] : null;

		console.log('objectSelected ==> ', objectSelected);

		this.mobMobilier = this.returnNewMobObject(_presta);
		this.mobMobilier.CMO_REF_ROOT = (!this.mobMobilier.CMO_REF_ROOT && currentCmoRefRoot) ? currentCmoRefRoot : this.mobMobilier.CMO_REF_ROOT;

		if (_presta.hasDetailActive && objectSelected) {
			this.mobMobilier.cols = objectSelected.cols;
			console.log("this.mobMobilier.cols ==> ", this.mobMobilier.cols);

			//let obligatoires: any = [];
			//this.mobMobilier.cols.forEach((col: any) => {
			//  if (col.model && col.isOblig) obligatoires.push(col.model);
			//})
			//this.mobMobilier.obligatoires = cloneDeep(obligatoires);

			let arrSousCat: any;
			this.app.apiToolsService.getElementsByIdMere(parseInt(objectSelected.cmoId)).subscribe(resp => {
				console.log("resp getElementsByIdMere ==> ", resp);
				arrSousCat = cloneDeep(resp);
				this.mobMobilier.arrSousCat = JSON.parse(arrSousCat);
			})
		}

		console.log('this.mobMobilier ==> ', this.mobMobilier);

	}

	// ==> Functions for standing stars
	getClassChecked(_opt: any, _el: any) {
		if (!_opt) return;
		let isMinorOrEqual: boolean = false;
		isMinorOrEqual = (_opt.value <= _el.MOB_STANDING) ? true : false;

		return isMinorOrEqual;
	}

	onClickStandingElement(_opt: any, _el: any, _presta: any) {
		// ==> Si on click sur en element déjà enregistré pendant qu'on est en train de saisir un nouveau mobilier, alors on affiche une alerte pour dire qu'il faut enregistrer le mob en cours avant ou sinon il va se perdre.
		if (_el.synthese) {
			if (this.mobMobilier) {
				this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalSaisieEnCours, "confirm", "", () => {
					console.log("Yes clicked");
					_el.MOB_STANDING = _opt.value;
					this.saveMobilier(_el);
					return;
				}, () => {
					console.log("No clicked");
				})
			} else {
				_el.MOB_STANDING = _opt.value;
				this.saveMobilier(_el);
			}
		} else {
			_el.MOB_STANDING = _opt.value;
		}
	}

	onClickDetailMobCuisine() {
		let modal: any = {
			name: "modal-meubles-cuisine",
			data: this.paramPicId
		}

		localStorage.setItem('modalOpen', JSON.stringify(modal));

		//Open modal
		this.app.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
			console.log("Yes clicked");
		}, () => {
			localStorage.removeItem("modalOpen");
			console.log("No clicked");
		})
	}

	// ==> Function for détail
	onClickDetailMob(_el: any, _prestaParent: any) {
		console.log("onClickDetailMob _el ==> ", _el);
		console.log("onClickDetailMob _prestaParent ==> ", _prestaParent);
		this.currentCategorieLibelle = null;

		// ==> Si le mob est meubles cuisine (à changer quand on aura les vrai cmo ref ou cmo id) et la presta sca_id est 6 (Amenagement)
		if (_prestaParent.SCA_ID == 6 && _el.CMO_REF_ROOT == "CUI_M") {
			this.onClickDetailMobCuisine();
			return;
		}

		if (_prestaParent.SCA_ID == 6 && _el.CMO_REF_ROOT == "CUI_E") {
			this.onClickDetailMobCuisine();
			return;
		}

		// ==> Sinon
		let prestaDetail: any = null;

		prestaDetail = this.arrScaByPicId.filter((presta: any) => {
			return (presta.SCA_ID == 99);
		})[0];

		if (prestaDetail) prestaDetail.idParent = _prestaParent.SCA_ID;

		this.changeTabNew(this.arrScaByPicId, prestaDetail);

		_prestaParent.hasDetailActive = (prestaDetail.idParent == _prestaParent.SCA_ID) ? true : false;
		//console.log("prestaDetail ==> ", prestaDetail);

		localStorage.setItem("prestaParentId", _prestaParent.SCA_ID);
		localStorage.setItem("currentElId", _el.CMO_REF_ROOT);

		this.currentCatId = localStorage.getItem("currentElId");
		//console.log("currentCatId ==> ", this.currentCatId);

		this.prestaParent = cloneDeep(_prestaParent);
		//console.log("prestaParent ==> ", this.prestaParent);

		this.currentCategorie = this.prestaParent.arrCategoriesSelected.filter((cat: any) => {
			return (cat.CMO_REF_ROOT == this.currentCatId);
		})[0];
		this.calculTotalPrix(this.currentCategorie);

		//console.log("this.mobMobilier==> ", this.mobMobilier);

		console.log("currentCategorie ==> ", this.currentCategorie);

		// ==> Ici je recup le libellé de la current category pour l'aficher dans la table detail
		//currentCategorieLibelle
		let currentCatInJson: any = this.prestaParent.optionsCategories.filter((cat: any) => {
			return (cat.cmoRef == this.currentCatId);
		})[0];
		console.log("currentCatInJson ==> ", currentCatInJson);

		if (currentCatInJson) this.currentCategorieLibelle = currentCatInJson.cmoLibelle;

		if (!this.currentCategorie || !this.currentCategorie.arrElementsSelected || this.currentCategorie.arrElementsSelected.length < 1) return;

		this.currentCategorie.arrElementsSelected.forEach((elSelected: any) => {
			let categorie: any;

			categorie = elSelected.synthese.options.filter((cat: any) => {
				return (cat.cmoRef == this.currentCatId);
			})[0];
			console.log("categorie ==> ", categorie);

			elSelected.CMO_ID = parseInt(elSelected.CMO_ID);
			let obligatoires: any = [];

			if (categorie) {
				elSelected.synthese.cols = categorie.cols;
				elSelected.synthese.colsId = categorie.colsId;
				elSelected.hasDetail = false;
				elSelected.isDetail = true;

				elSelected.synthese.cols.forEach((col: any) => {
					if (col.model && col.isOblig) obligatoires.push(col.model);
				})

				elSelected.obligatoires = cloneDeep(obligatoires);
			}
		});

		this.arrSousCat = [];
		// ==> Ici on recupere par api les enfants de la categorie selectionnee
		this.getElementsByIdMere(this.currentCategorie.CMO_ID_ROOT);
	}

	calculTotalPrix(_presta: any) {
		if (!_presta.arrCategoriesSelected) return;

		// ==> On remets le prix Total à 0 pour recalculer
		_presta.PRIX_TOTAL = 0;
		//console.log("_presta.PRIX_TOTAL ==>", _presta.PRIX_TOTAL)

		// ==> On recalcule le prix total
		if (_presta.arrCategoriesSelected.length > 0) {
			_presta.arrCategoriesSelected.forEach((cat: any) => {
				cat.PRIX_TOTAL = 0;
				if (cat.arrElementsSelected.length > 0) {
					cat.arrElementsSelected.forEach((mob: any) => {
						mob.MOB_PRIX_TOTAL = (mob.MOB_PRIX_TOTAL) ? mob.MOB_PRIX_TOTAL : 0;
						let prixTotalTemp = +mob.MOB_PRIX_TOTAL;
						cat.PRIX_TOTAL = cat.PRIX_TOTAL + prixTotalTemp;
						cat.PRIX_TOTAL = +cat.PRIX_TOTAL.toFixed(2);

						_presta.PRIX_TOTAL = _presta.PRIX_TOTAL + prixTotalTemp;
						_presta.PRIX_TOTAL = +_presta.PRIX_TOTAL.toFixed(2);
					});
				}
			});

		}
	}

	onKeyUpFieldMob(_el: any, _key: any, _presta: any, isNew: boolean) {
		// console.log("_el ==> ", _el);
		// console.log("_presta ==> ", _presta);
		let currentCat: any = null;

		// CMO_ID_ROOT et arrCategoriesSelected CMO_ID_ROOT
		if (_presta.arrCategoriesSelected && _presta.arrCategoriesSelected.length > 0) {
			currentCat = _presta.arrCategoriesSelected.filter((cat: any) => {
				return cat.CMO_ID_ROOT == _el.CMO_ID_ROOT;
			})[0];
		}

		_el.toSave = false;

		if (!isNew) {
			_el.toSave = true;
			_el.MOB_PRIX_TOTAL = null;
			_presta.PRIX_TOTAL = null;
			if (currentCat) currentCat.PRIX_TOTAL = null;
		}
	}

	checkValidators(_el: any) {
		if (!_el.obligatoires) return 0;

		let nbErrors = 0;

		_el.obligatoires.forEach((champ: any) => {
			if (!_el[champ]) nbErrors++;
		})

		return nbErrors;
	}

	isChampVisibleForMob(_mob: any, colPrestaId: any) {
		//console.log("_mob ==>", _mob);
		//
		let colInElement: any;

		if (_mob.isDetail) {
			colInElement = _mob.synthese.cols.filter((col: any) => {
				return col.id == colPrestaId;
			})[0];
		} else {
			if (_mob.cols) colInElement = _mob.cols.filter((col: any) => {
				return col.id == colPrestaId;
			})[0];
		}

		//colInElement = _mob.cols.filter((col: any) => { return col.id == colPrestaId; })[0];
		let value = (colInElement) ? true : false;
		return value;
	}

	/* ------------------------------------------------------------------------------ PRESTA PEINTURE */
	fctWhenIsAutreSelected(_srf: any) {
		console.log("fctWhenIsAutreSelected _srf ==> ", _srf);

		let listFin = (_srf.TSF_ID == 1) ? this.arrFinitionsPlafond : (_srf.TSF_ID == 6) ? this.arrFinitionsSol : this.arrFinitionsMur;

		_srf.arrFinitionsSelected.forEach((fin: any) => {
			if (fin.RFR_ID == null) return;

			let isinListFinitions: any = listFin.filter((_finInList: any) => {
				return _finInList.RFR_ID == fin.RFR_ID
			})[0];

			if (!isinListFinitions) {
				let arrayToPass = (_srf.TSF_ID == 1) ? this.arrFinitionsPlaDataTreeView : (_srf.TSF_ID == 6) ? this.arrFinitionsSolDataTreeView : this.arrFinitionsMurDataTreeView;

				let isInAutreListFinitions: any = this.findNodeById(arrayToPass, fin.RFR_ID.toString());
				//console.log("isInAutreListFinitions ==> ", isInAutreListFinitions);

				if (isInAutreListFinitions) {

					let finToPush: any = {
						RFR_ID: +isInAutreListFinitions.Id,
						RFR_LIBELLE: isInAutreListFinitions.Label,
						disabled: true
					}

					listFin.unshift(finToPush);
				}
			}
		})
	}

	onClickDetailMur(_tsf: any, _prestaParent: any) {
		this.isDetailMur = true;

		//console.log("onClickDetailMob _tsf ==> ", _tsf);
		//console.log("onClickDetailMob _prestaParent ==> ", _prestaParent);

		this.currentCatId = null;
		this.currentCatTsfId = null;
		let prestaDetail: any = null;

		prestaDetail = this.arrScaByPicId.filter((presta: any) => {
			return (presta.SCA_ID == 99);
		})[0];
		if (prestaDetail) prestaDetail.idParent = _prestaParent.SCA_ID;
		_prestaParent.hasDetailActive = (prestaDetail.idParent == _prestaParent.SCA_ID) ? true : false;
		console.log("onClickDetailMob prestaDetail ==> ", prestaDetail);

		this.changeTabNew(this.arrScaByPicId, prestaDetail);

		localStorage.setItem("currentElId", _tsf.TSF_ID);
		this.currentCatId = localStorage.getItem("currentElId");

		if (this.currentCatId) {
			this.currentCatTsfId = this.arrSrfRfs.filter((tsf: any) => {
				return (tsf.TSF_ID == this.currentCatId);
			})[0];

			this.currentCatTsfId.arrElementsSelected.forEach((item: any) => {
				item.isDoubleFinition = (item.RFS_NB_FINITIONS == 1) ? false : true;
				item.valueSlider = this.getValueRfsRefForSlider(item);

				//this.fctWhenIsAutreSelected(item);
			})
		}

		this.prestaParent = cloneDeep(_prestaParent);
	}

	createArrayChildsTree(_treeview: any) {
		_treeview.forEach((node: any) => {
			if (node.children && node.children.length > 0) {
				this.createArrayChildsTree(node.children);
			} else {
				this.listTreeLastItems.push(node);
			}
		})
		return this.listTreeLastItems;
	}

	findNodeById(tree: any, _finId: any) {
		let result: any = null;
		this.listTreeLastItems = [];
		this.listTreeLastItems = this.createArrayChildsTree(tree);

		result = this.listTreeLastItems.filter((_finInList: any) => {
			return _finInList.Id == _finId
		})[0];

		return result;
	}

	onChangeIsDoubleFinition(_mur: any) {
		_mur.isDoubleFinition = !_mur.isDoubleFinition;
	}

	onChangeFinition(_tsf: any, _rfr: any) {
		//console.log(_tsf, _rfr);

		let tsfId: number = +_tsf.TSF_ID;
		console.log("tsfId ==> ", tsfId);

		if (_rfr.RFR_ID == -999) { //ouvrir modal treeview
			let arrayToPass = (tsfId == 1) ? this.arrFinitionsPlaDataTreeView : (tsfId == 6) ? this.arrFinitionsSolDataTreeView : this.arrFinitionsMurDataTreeView;
			this.onClickAutresFinitions(arrayToPass, _rfr);
		} else {
			//console.log(_tsf)
			this.onSaveSolOrPlafond(_tsf.arrElementsSelected[0]);
		}
	}

	getFinitionsByTsfId(_tsfId: any) {
		let arrFinitions: any = [];

		switch (_tsfId) {
			case 1:
				arrFinitions = this.arrFinitionsPlafond;
				break;

			case 6:
				arrFinitions = this.arrFinitionsSol;
				break;

			default:
				arrFinitions = [];
				break;
		}
		return arrFinitions;
	}

	getValueRfsRefForSlider(mur: any) {
		let valueSlider;

		switch (mur.RFS_ID) {
			case 2:
				valueSlider = 100;
				break;

			case 3:
				valueSlider = 50;
				break;

			case 16:
				valueSlider = 70;
				break;

			case 18:
				valueSlider = 30;
				break;

			default:
				valueSlider = 100;
				break;
		}

		return valueSlider;
	}

	onCopyRfrAllMurs(_mur: any) {
		console.log("onCopyRfrAllMurs : _mur ==> ", _mur);

		this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalRecopierSurMurs, "confirm", "", () => {
			this.formatDataMurs(_mur);
			return;
		}, () => {
			console.log("Annuler onCopyRfrAllMurs");
		})
	}

	formatDataMurs(_mur: any) {
		if (this.currentCatTsfId) {
			if (this.currentCatTsfId.arrElementsSelected.length > 0) {

				this.currentCatTsfId.arrElementsSelected.forEach((mur: any) => {
					if (mur.SRF_ID != _mur.SRF_ID) {
						mur.DMG_RENOVER = _mur.DMG_RENOVER;
						mur.DMG_ISOLER = _mur.DMG_ISOLER;
						mur.RFS_NB_FINITIONS = _mur.RFS_NB_FINITIONS;
						mur.DMG_ABATTRE = _mur.DMG_ABATTRE;
						mur.valueSlider = _mur.valueSlider;
						mur.isDoubleFinition = _mur.isDoubleFinition;
						mur.RFS_ID = _mur.RFS_ID;

						mur.arrFinitionsSelected = [];

						_mur.arrFinitionsSelected.forEach((fin: any) => {
							let finObj: any = {
								DMG_ID: mur.DMG_ID,
								DMG_RFR_PCT: fin.DMG_RFR_PCT,
								RFR_ID: fin.RFR_ID,
							}
							mur.arrFinitionsSelected.push(finObj);
						})
					}
				});

			}
		}
	}

	sliderEvent(_mur: any) {
		_mur.RFS_ID = this.getRfsIdByValueSlider(_mur.valueSlider);

		if (_mur.arrFinitionsSelected.length > 0) {

			if (_mur.valueSlider != 0 && _mur.valueSlider != 100) {
				if (_mur.arrFinitionsSelected.length == 1) {
					_mur.arrFinitionsSelected[0].DMG_RFR_PCT = _mur.valueSlider;
					//_mur.RFS_ID = this.getRfsIdByValueSlider(_mur.valueSlider);

					console.log("valueSlider => ", _mur.valueSlider);
					console.log("DMG_RFR_PCT => ", _mur.arrFinitionsSelected[0].DMG_RFR_PCT);

					let finition: any = {
						DMG_ID: _mur.DMG_ID,
						DMG_RFR_PCT: 100 - _mur.arrFinitionsSelected[0].DMG_RFR_PCT,
						RFR_ID: null
					}

					console.log("finition => ", finition);

					_mur.arrFinitionsSelected.push(finition)
				} else {
					_mur.arrFinitionsSelected[0].DMG_RFR_PCT = _mur.valueSlider;
					_mur.arrFinitionsSelected[1].DMG_RFR_PCT = 100 - _mur.valueSlider;
					//_mur.RFS_ID = this.getRfsIdByValueSlider(_mur.valueSlider);
				}
			} else {
				_mur.arrFinitionsSelected[0].DMG_RFR_PCT = 100; //(_mur.valueSlider != 100) ? 100 : _mur.valueSlider;

				if (_mur.arrFinitionsSelected.length > 1) {
					let indexToDelete = _mur.arrFinitionsSelected.findIndex((fin: any) => {
						return fin.DMG_RFR_PCT != _mur.arrFinitionsSelected[0].DMG_RFR_PCT;
					});
					console.log("indexToDelete => ", indexToDelete);
					_mur.arrFinitionsSelected.splice(indexToDelete, 1);
				}

				console.log("_mur.arrFinitionsSelected: ==> ", _mur.arrFinitionsSelected);
			}
		}

		console.log("_mur: ==> ", _mur);
	}

	getRfsIdByValueSlider(_value: any) {
		let rfsId: any = null;
		switch (_value) {
			case 30:
				rfsId = 18; //MUR_2F_30_70
				break;
			case 50:
				rfsId = 3; //MUR_2F_50_50
				break;
			case 70:
				rfsId = 16; //MUR_2F_70_30
				break;
			default:
				rfsId = 2; //MUR_SANS_CARRELAGE
				break;
		}

		return rfsId;
	}

	onChangeDmgRenover(_srf: any) {
		console.log("_srf: ==> ", _srf);

		this.pushItemInListAndSave(_srf);
	}

	pushItemInListAndSave(_srf: any) {
		console.log(" pushItemInListAndSave _srf: ==> ", _srf);
		let listItemsToRenove: any = [];
		listItemsToRenove.push(_srf);

		this.onSaveListDmgRfr(listItemsToRenove);
	}

	returnAllFinitionsAreOk(_list: any) {
		let finAreValid: boolean = true;
		let listDmgIdNotValids: any = [];

		_list.forEach((srf: any) => {
			if (srf.DMG_RENOVER && (!srf.arrFinitionsSelected || srf.arrFinitionsSelected.length == 0)) {
				listDmgIdNotValids.push(srf.DMG_ID);
			}

			if (srf.arrFinitionsSelected.length > 0) {
				srf.arrFinitionsSelected.forEach((fin: any) => {
					if (srf.DMG_RENOVER && !fin.RFR_ID) listDmgIdNotValids.push(srf.DMG_ID);
				})
			}
		})

		if (listDmgIdNotValids.length > 0) {
			this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalSaveSrfInvalid, "alert", "", () => {
				return;
			}, () => {
				return;
			})
			return;
		}

		finAreValid = (listDmgIdNotValids.length > 0) ? false : true;

		return finAreValid;
	}

	onSaveSolOrPlafond(_srf: any) {
		//if (_srf.arrFinitionsSelected.length > 0) {
		//  _srf.arrFinitionsSelected.forEach((fin: any) => {
		//    fin.isFinValid = (_srf.DMG_RENOVER && !fin.RFR_ID) ? false : true;
		//    console.log("fin.isFinValid: ==> ", fin.isFinValid);
		//  })
		//}

		let listSrf: any = [];
		listSrf.push(_srf);

		let listIsOk = this.returnAllFinitionsAreOk(listSrf);

		if (!listIsOk) {
			this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalSaveSrfInvalid, "alert", "", () => {
				return;
			}, () => {
				return;
			})
			return;
		}

		//listSrf.forEach((srf: any) => {
		//  delete srf.DMG_PRIX;
		//})

		console.log("listSrf: ==> ", listSrf);

		if (!this.isDetailMur) this.onSaveListDmgRfr(listSrf);
	}

	onSaveAllMurs(_listMurs: any) {
		console.log("this.isDetailMur", this.isDetailMur);
		console.log("_listMurs: ==> ", _listMurs);

		_listMurs.forEach((mur: any) => {
			mur.RFS_NB_FINITIONS = (mur.arrFinitionsSelected.length > 0) ? mur.arrFinitionsSelected.length : null;
			mur.isDoubleFinition = (mur.RFS_NB_FINITIONS == 2) ? true : false;
			delete mur.RFS_REFERENCE;
		})

		let listIsOk = this.returnAllFinitionsAreOk(_listMurs);

		if (!listIsOk) {
			this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalSaveSrfInvalid, "alert", "", () => {
				return;
			}, () => {
				return;
			})
			return;
		}

		this.onSaveListDmgRfr(_listMurs);
	}

	onChangeCheckDmg(_srf: any) {
		this.pushItemInListAndSave(_srf);
	}

	onSaveListDmgRfr(_SrfRenovationMto: any) {
		console.log("_SrfRenovationMto: ==> ", _SrfRenovationMto);

		this.app.apiToolsService.setDmgModernisationSet(_SrfRenovationMto).subscribe(resp => {
			console.log("resp setDmgModernisationSet ==> ", resp);

			setTimeout(() => {
				this.sidebarRecap.getSimulationEncart(this.batiment.simulationId);
				this.sbC.update();
				this.getSrfRfsDmgGet(this.paramPicId);

				// Détection de la presta "peinture" : on utilise currentPrestaActive si disponible,
				// sinon on tente de récupérer `currentPresta` depuis le localStorage.
				// Récupération sécurisée de la presta courante
				const currentPresta = this.currentPrestaActive || (() => {
					try { return JSON.parse(localStorage.getItem("currentPresta") || 'null'); }
					catch (e) { return null; }
				})();

				console.log("currentPresta ==> ", currentPresta);

				// Reload seulement si on est dans le détail d'une presta et que le parent est la presta 'peinture' (SCA_ID === 1)
				const isDetailPresta = !!currentPresta && Number(currentPresta.SCA_ID) === 99;
				const isParentPeinture = !!currentPresta && (Number(currentPresta.idParent) === 1 || Number(currentPresta.idParent) === Number(1));

				if (isDetailPresta && isParentPeinture) {
					this.changeTabNew(this.arrScaByPicId, this.prestaParent)
				}

				//location.reload();
			}, 1);
		})
	}

	onSaveRfr(_mur: any) {
		console.log("TO DO onSaveRfr : _mur ==> ", _mur);
		alert("TO DO onSaveRfr : _mur ==> " + JSON.stringify(_mur));
	}

	onDeleteRfr(_mur: any) {
		console.log("TO DO onDeleteRfr : _mur ==> ", _mur);
		alert("TO DO onDeleteRfr : _mur ==> " + JSON.stringify(_mur));
	}
}
